import { isBefore, isEqual, isValid, parseISO } from "date-fns";
import { z } from "zod";

export const CheckAvailabilitySchema = z.object({
    availability: z.coerce.number(),
    date_from: z.string().refine((value) => isValid(parseISO(value)), {
        message: "Start date is invalid",
    }),
    date_to: z.string().refine((value) => isValid(parseISO(value)), {
        message: "End date is invalid",
    }),
    room_type_id: z.string(),
}).superRefine((data, ctx) => {
    const startDate = parseISO(data.date_from);
    const endDate = parseISO(data.date_to);

    // Ensure start date is valid
    if (!isValid(startDate)) {
        ctx.addIssue({
            path: ['date_from'],
            message: "Start date is invalid",
            code: z.ZodIssueCode.custom,
        });
    }

    // Ensure end date is valid
    if (!isValid(endDate)) {
        ctx.addIssue({
            path: ['date_to'],
            message: "End date is invalid",
            code: z.ZodIssueCode.custom,
        });
    }

    // Ensure start date is before or equal to end date
    if (isValid(startDate) && isValid(endDate) && !isBefore(startDate, endDate) && !isEqual(startDate, endDate)) {
        ctx.addIssue({
            path: ['date_to'],
            message: "End date must be after or equal to start date",
            code: z.ZodIssueCode.custom,
        });
    }
});